import { Component, EventEmitter, Input, Output, SimpleChanges, inject } from '@angular/core';
import { ICliente, IReporteBase } from 'modelos/src';
import { LoadingService } from '../../../../../../../auxiliares/servicios/loading.service';
import { LoginService } from '../../../../../../login/login.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-info-reporte',
  templateUrl: './info-reporte.component.html',
  styleUrl: './info-reporte.component.scss',
  standalone: false,
})
export class InfoReporteComponent {
  loading = inject(LoadingService);
  dialog = inject(MatDialog);
  navigator = inject(Router);

  //Recibidos de la barra lateral
  @Input() public reporte?: IReporteBase<'Tracker 4G'>; //Reporte seleccionado

  //Enviados a la barra lateral
  @Output() public reporteChange = new EventEmitter<
    IReporteBase<'Tracker 4G'>
  >(); //Cambio en el reporte seleccionado
  @Output() public salirDetalleChange = new EventEmitter<boolean>(); //Cerrar detalle del reporte

  public cliente?: ICliente;

  constructor() {
    this.cliente = LoginService.getCliente();
  }

  //FUNCIONES PARA INTERACCIÓN CON LA BARRA LATERAL:
  public close() {
    this.salirDetalleChange.emit(true);
  }

  //AUXILIARES
  public getFoto() {
    return (
      `url("${this.reporte?.usuario?.datosPersonales?.foto}")` ||
      `url("https://static.vecteezy.com/system/resources/previews/018/765/757/original/user-profile-icon-in-flat-style-member-avatar-illustration-on-isolated-background-human-permission-sign-business-concept-vector.jpg")`
    );
  }
}
